// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { SubMenuItemFragmentDoc } from './SubMenuItem.fragment.generated';
export const SubMenuSectionFragmentDoc = gql`
    fragment subMenuSection on SubMenuSection {
  __typename
  title
  items {
    ...subMenuItem
  }
}
    ${SubMenuItemFragmentDoc}`;